import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import "./App.scss";
import SignupMainBody from "./components/creator-signup/SignupMainBody";
import Dashboard from "./components/dashboard/Dashboard";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import useGetInfluencerById from "./utils/useGetInfluencerById";
import { addInfluencer, setLoading } from "./utils/influencerSlice";
import CampaignDetails from "./components/dashboard/CampaignDetails";
import ApplyCampaigns from "./components/applyCampaigns/ApplyCampaigns";

function App() {
  const dispatch = useDispatch();
  const id = localStorage.getItem("influencerId");
  const [influencer, isLoading] = useGetInfluencerById(id);
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  useEffect(() => {
    if (isLoading !== undefined) {
      dispatch(setLoading(isLoading));
    }

    if (influencer) {
      dispatch(addInfluencer(influencer));
    }
  }, [isLoading, influencer, dispatch]);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decodedToken = jwtDecode(token);
      if (Date.now() >= decodedToken.exp * 1000) {
        handleLogout();
      } else {
        const expiryTime = decodedToken.exp * 1000 - Date.now();
        setTimeout(() => {
          handleLogout();
        }, expiryTime);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: isAuthenticated ? (
        <Dashboard onLogout={handleLogout} />
      ) : (
        <Navigate to={"/login"} />
      ),
    },
    {
      path: "/campaign-details/:id",
      element: isAuthenticated ? (
        <CampaignDetails onLogout={handleLogout} />
      ) : (
        <Navigate to={"/login"} />
      ),
    },
    {
      path: "/signup",
      element: !isAuthenticated ? (
        <SignupMainBody onLogin={handleLogin} />
      ) : (
        <Navigate to={"/"} />
      ),
    },
    {
      path: "/login",
      element: !isAuthenticated ? (
        <SignupMainBody onLogin={handleLogin} />
      ) : (
        <Navigate to={"/"} />
      ),
    },
    {
      path: "/apply-campaigns",
      element: isAuthenticated ? (
        <ApplyCampaigns onLogout={handleLogout} />
      ) : (
        <Navigate to={"/login"} />
      ),
    },
  ]);
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
